module.exports = __webpack_public_path__ + "static/media/Facebook.47b64310.svg";